import styled from 'styled-components/macro'
import Box from 'components/shared/Box'
import benefitsInfoDecor from 'assets/images/decors/benefitsInfoDecor.svg'
import { respondAbove } from 'styles/mediaQueries'

export const BenefitsInfoBox = styled(Box)`
    width: 100%;
    background: url(${benefitsInfoDecor}),
        ${({ theme }) => theme.colors.grayscale_0};
    background-repeat: no-repeat;
    border-radius: 9px;
    > :nth-child(1) {
        width: 100% !important;
    }
    @media ${respondAbove.xl} {
        background-position-x: -26px;
        position: sticky;
        top: 24px;
        margin-bottom: 244px;
    }
`
